module.exports = __webpack_public_path__ + "img/shopping-bag.95af52cb.svg";